window.addEventListener('DOMContentLoaded', function () {
    var isTypeurl = window.location.href;//判断是否是详情页
    if (isTypeurl.indexOf('products') != -1) {

        add_button();      
         if($(window).width() <=785){
           $('.product-page--social-media .station-tabs-tabset h3.station-tabs-tabtitle').eq(0).find('span').trigger("click")
         }
    }

    setTimeout(AddSize, 1500);
    setTimeout(Txtinput, 2000);
    setTimeout(Addinfo, 1000);
    setTimeout(productCus, 1000);

    var makeupTheDifferenceQty = '';
  if(getUrlParam('_qty') !=null){
    makeupTheDifferenceQty = getUrlParam('_qty');
  }else{
     makeupTheDifferenceQty = getUrlParam('_amount');
  }
    if (makeupTheDifferenceQty != null) {
        $("input[name='quantity']").val(makeupTheDifferenceQty);
    }

    $('#mi-close').click(function () {
        document.getElementById("mi-popup-kk").style.display = 'none';
        document.getElementById("mask-mi").style.display = 'none';
    })

    $('#mask-mi').click(function () {
        $(this).css('display', 'none');
        $('#mi-popup-kk').css('display', 'none');
        document.getElementById("buttom-x").style.display = 'none';//wwh8.4新增
        $("body").css('overflow', '')//wwh8.5新增
        $('.font-popup-kk').css('display', 'none'); // hf 25.4.23
    });

       $('.mi-close-custom').click(function () {
        document.getElementById("mi-popup-kk").style.display = 'none';
        document.getElementById("mask-mi").style.display = 'none';
        document.getElementById("buttom-x").style.display = 'none';
        $("body").css('overflow', '')
    });

    var interval1 = setInterval(() => {
        if ($('.size-cm')) {
            $('.size-cm').click(function () {
                $(this).addClass('size_checked')
                $('#inTable').addClass('size_hidden');;
                $('#cmTable').removeClass('size_hidden');
                $('.size-in').removeClass('size_checked')
            })
            $('.size-in').click(function () {
                $(this).addClass('size_checked');
                $('#cmTable').addClass('size_hidden');
                $('#inTable').removeClass('size_hidden');
                $('.size-cm').removeClass('size_checked')
            })

            clearInterval(interval1);
        }
    }, 1000);

    var interval2 = setInterval(() => {
        var bcpo = $('#customized_bigtur');
        if (bcpo.length > 0) {
             $('.question_buttons').click(function () {
              $(this).parents('.bigtur_wrapper').find('.bubble.tip-top').stop(true, true).slideDown();            
           })   
          $(document).on('click', function(event) {
            var target = $(event.target);
            if (!target.closest('.question_buttons').length) {
              $('.bubble.tip-top').slideUp();
            }
          });
            clearInterval(interval2);
        }
    }, 1000);





    // 商品主图焦点显示

    // 手机端
    var index = 0;
    var M_width = 14.2857;
    var M_box = $(' .carousel--x-container');
    var M_list = $('.carousel--block');

    $(".carousel--viewport .slick-next").click(function () {
        if (index == M_list.length - 1) {
            index = -1;
        }
        index++;
        var width = -(index * M_width) + "%";

        M_box.css("transform", "translateX(" + width + ")");

    })

    $(".carousel--viewport .slick-prev").click(function () {
        if (index == 0) {
            index = M_list.length;
        }
        index--;
        var width = -(index * M_width) + "%";

        M_box.css("transform", "translateX(" + width + ")");

    })


  // 视频
      if (isTypeurl.indexOf('products') != -1) {
            var interval3 = setInterval(() => {
                if ($('#insta-feed .instafeed-container').length > 0) {
                  console.log($('.instafeed-container'))
                  $('#insta-feed .instafeed-video').click(function () {
                    var video_id = $(this).parents('a').attr('href');
                    console.log($(video_id).find('video'))
                    $(video_id).find('video').prop('muted', false)
                     })
                     clearInterval(interval3);    
                }
             }, 1000);    
      }
})

function getUrlParam(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
    var r = window.location.search.substr(1).match(reg);  //匹配目标参数
    if (r != null) return unescape(r[2]); return null; //返回参数值
}



function Addinfo() {
  var mi = $('input[type=radio][name="properties[Material]"]').parents('.bigtur_buttons').find('.bigtur_div_extend');
  var obj = $("div[class='bigtur_wrapper bigtur_simple bigtur_buttons']");
  if (typeof obj.html() == "undefined" || obj == null) {
    setTimeout(Addinfo, 1000);
  } else {
    mi.append(
      `<div class="scmi_div"><a href="javascript:void(0);" class="scmi" onclick="ClickMi()">Comparing Methods</a><a></a></div>`
    );
    mi.css('display', 'block');
  }
}


// function activeCheckout() {
//     var act = $("button[name='checkout']");
//     act.removeAttr("disabled");
//     act.click(function () {
//         act.attr("disabled", "disabled");
//     });
// }

function Txtinput() {
    var _title = $("input[class='product-type']").val();
    var regRule = /[^\u4E00-\u9FA5|\d|\a-zA-Z|\r\n\s,.?!，。？！…―——_'"^%#@\·~&<>《》$=()+-/*{}[\]]|(^\s*)/g;
    if (_title === 'Hat') {
        var regRule = /[^\u4E00-\u9FA5|\d|\a-zA-Z]/g;
    }

    if ($("input[name='properties[Back Number]']").attr("data-price") != null) {

        // 判断是ios还是安卓
        if (ios_or_android() == 'ios') {
            $("input[type='text']").on("keyup", function () {
                var param = $(this).val();
                $(this).val(param.replace(regRule, ""));
            })
        } else {
            $("input[type='text']").on("input", function () {
                var param = $(this).val();
                $(this).val(param.replace(regRule, ""));
            })
        }
    } else {
        setTimeout(Txtinput, 3000);
    }
}


/*
        @功能：判断终端是ios还是安卓
         */
function ios_or_android() {
    var u = navigator.userAgent;
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

    if (isAndroid) {
        return 'and';
    } else {
        return 'ios';
    }
}


function AddSize() {
    var obj = $("div[class='bigtur_wrapper bigtur_simple bigtur_default']");
    var modal = '<br/> <a class="sizechartlabel" data-toggle="modal" data-target="#modalProductInfo" href="#" style="padding: 10px;display: block;"><span class="icon-f-09"></span> Size guide</a>';
    if (typeof (obj.html()) == "undefined" || obj == null) {

        setTimeout(AddSize, 1000);

    } else {

        obj.each(function () {

            $(this).find("div").eq(1).append(modal);
        });

    }
}

function ClickMi() {
    document.body.style.overflow = 'hidden';
    //wwh8.4新增
    document.getElementById("buttom-x").style.display = 'block';
    var mi_popup_height = $("#mi-popup-kk").height() + 25;
    var buttomleftvalue = ($('body').width() - $("#buttom-x").width()) > 0 ? ($('body').width() - $("#buttom-x").width()) : ($("#buttom-x").width() - $('body').width())
    $(".buttom-x").css({
        top: mi_popup_height + 'px',
        left: buttomleftvalue / 2 + 'px',
    })
    $("#mask-mi").css("height", $(document).height());
    $("#mask-mi").css("width", $(document).width());
    $("#mask-mi").show();
    var $Popup = $('.mi-popup-kk');
    var leftvalue = ($('body').width() - $Popup.width()) > 0 ? ($('body').width() - $Popup.width()) : ($Popup.width() - $('body').width())

    var topvalue = ($(window).height() - $Popup.height() - 350) >= 0 ? '3' : '4';

    $Popup.css({
        left: leftvalue / 2 + 'px',
        top: topvalue / 2 + "rem",
        display: 'block',
        position: 'fixed'
    });
    //wwh新增
    var _title = $(".product-page--title").html();
    if (_title.indexOf('Baseball') != -1) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopifycdn.net/s/files/1/0445/3587/3698/files/baseball_219fd43a-4252-4517-9914-0e4c0b99a61e.jpg?v=1659596354");
    }
    if (_title.indexOf('Basketball') != -1) {
        if (_title.indexOf('Shorts') != -1) {
            $("#Img_MaterialInstruction").attr("src", "https://cdn.shopifycdn.net/s/files/1/0445/3587/3698/files/shorts.jpg?v=1659596354");
        } else if (_title.indexOf('Suit') != -1) {
            $("#Img_MaterialInstruction").attr("src", "https://cdn.shopifycdn.net/s/files/1/0445/3587/3698/files/basketball_suit_76acdc09-4ccb-4b27-ac73-7e4a75a2bd7a.jpg?v=1659596354");
        } else {
            $("#Img_MaterialInstruction").attr("src", "https://cdn.shopifycdn.net/s/files/1/0445/3587/3698/files/basketball_da1ff709-2631-4755-9f3f-b3ae91d70c39.jpg?v=1659596354");
        }
    }
    if (_title.indexOf('Football') != -1) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopifycdn.net/s/files/1/0445/3587/3698/files/football_fe7e41e8-be36-4412-908f-bdf8a5f71f5e.jpg?v=1659596354");
    }
    if (_title.indexOf('Golf') != -1) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopifycdn.net/s/files/1/0445/3587/3698/files/golf.jpg?v=1659596354");
    }
    if (_title.indexOf('Hat') != -1) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopifycdn.net/s/files/1/0445/3587/3698/files/hats.jpg?v=1659596354");
    }
    if (_title.indexOf('Hockey') != -1) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopifycdn.net/s/files/1/0445/3587/3698/files/hockey.jpg?v=1659596354");
    }
    if (_title.indexOf('Hoodie') != -1) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopifycdn.net/s/files/1/0445/3587/3698/files/hoodies.jpg?v=1659596354");
    }
    if (_title.indexOf('Pants') != -1) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopifycdn.net/s/files/1/0445/3587/3698/files/pant.jpg?v=1659596354");
    }
    if (_title.indexOf('Soccer') != -1) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopifycdn.net/s/files/1/0445/3587/3698/files/soccer_b18e2250-daea-4aac-8bc8-dbe7fac31909.jpg?v=1659596354");
    }
    if (_title.indexOf('Jacket') != -1) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopify.com/s/files/1/0445/3587/3698/files/JD22101901.jpg?v=1666168588");
    }
    if (_title.indexOf('T-Shirt') != -1 && _title.indexOf('Long Sleeve') < 0) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopifycdn.net/s/files/1/0445/3587/3698/files/t-shirt_96c8c99b-ee96-46b0-a4e2-eb668c723d15.jpg?v=1659596354");
    }

    if (_title.indexOf('T-Shirt') != -1 && _title.indexOf('Long Sleeve') != -1) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopify.com/s/files/1/0278/0263/2328/files/TZ22082205-01.jpg?v=1665124550");
    }
    if (_title.indexOf('Jogger Sweatpants') != -1) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopify.com/s/files/1/0445/3587/3698/files/Blank.jpg?v=1667894022");
    }
  if (_title.indexOf('Volleyball') != -1) {
        $("#Img_MaterialInstruction").attr("src", "https://cdn.shopify.com/s/files/1/0445/3587/3698/files/AZ24072430.jpg?v=1722494930");
    }
}

function productCus() {
    var goods_name = ($('h2.product-page--title').text()).toLowerCase();
    var _upload = $("input[type='file']");
    if (_upload.attr("data-price") != null) {
        _upload.attr("accept", "image/png, image/jpeg,image/jpg");
        if (_upload.parent().html().indexOf("Upload Your Photo") <= -1) {
            $("span[class='bcpo-title']").each(function () {
                var htm = $(this).html();
                var title = $(this).text();
                if (htm.indexOf('Team Logo') > -1 || htm.indexOf('Back Logo') > -1 ||  htm.indexOf('Front - Your Picture') > -1) {
                    htm = "<font size=\"-2\">（Upload a file no less than 800px by 800px in AI, PDF, PNG, JPG format.）</font>";
                    $(this).append(htm);
                }
               if (htm.indexOf('Team Logo') > -1 || htm.indexOf('Back Logo') > -1 || htm.indexOf('Upload Logo') > -1 ||  htm.indexOf('Front - Your Picture') > -1) {
                   htm=htm.replace(":","<span class='question_file'><p>Don't upload copyrighted logos.</p></span>:");
                    $(this).html(htm);   
                }
                if (htm.indexOf('Choose Neckline') > -1) {
                    htm = ("<span>*</span>");
                    $(this).append(htm);
                } 

             if (htm.indexOf('*') > -1) {
                  if(htm.indexOf('Men\'s') >1 && goods_name.indexOf('soccer') >1){  
                          htm = htm.replace("*", "<span class='question_buttons'></span><span style='color:red;font-size: 20px;vertical-align: text-top;'>*</span>");
                       htm1 = "<div class='bubble tip-top' ><span style='color:#524e4e;font-weight: 450;'>Our soccer jerseys are slim fit;<br>For a <b>standard fit</b>, go one size up;<br>For casual wear, two sizes up is recommended for extra comfort.</span></div>"
                      $(this).parents('.bcpo-default').prepend(htm1) 
                      $(this).append(htm);
                  }else{
                    htm = htm.replace("*", "<span style='color:red;font-size: 20px;vertical-align: text-top;'>*</span>");
                    $(this).html(htm)
                  }

                      
                }
                $('.question_file').on({
                mouseover : function(){$(this).find('p').fadeIn(200).show()} ,
                mouseout : function(){$(this).find('p').fadeIn(200).hide()}
              }) ;
            });
        }
    }
    else {
        setTimeout(productCus, 100);
    }
}





//自定义获取图片路径函数
function getObjectURL(file) {
    var url = null;
    if (window.createObjectURL != undefined) { // basic
        url = window.createObjectURL(file);
    } else if (window.URL != undefined) { // mozilla(firefox)
        url = window.URL.createObjectURL(file);
    } else if (window.webkitURL != undefined) { // webkit or chrome
        url = window.webkitURL.createObjectURL(file);
    }
    return url;
}

function removeTip() {
    $('.tip-top').remove();
}

function add_button() {
    document.getElementById("product-add-to-cart").addEventListener('click', function (event) {
        var Material = $('input[value="Blank(No Name/Number)"]');
        var text = $('#customized_bigtur').find('input[type="text"]').parent();
        if ($('#customized_bigtur').find('input[type="file"]').length > 0) {
            var fileInput = $('#customized_bigtur').find('input[type="file"]').get(0).files[0];
        }
        if (Material.is(":checked") == false) {
            var num = 0;
            text.find('input').each(function () {
                if ($(this).val().length > 0) {
                    num = $(this).val().length;
                    return false;
                }
            });
            if (num == 0 && fileInput == undefined) {
                $('#customized_bigtur').find('input[type="text"]').attr("disabled", true);
                $('input[value="Blank(No Name/Number)"]').trigger("click");
            }
        }
    })

}